"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyBodyFetchGraphqlError = void 0;
var _axios = require("@ori/axios");
var _FetchGraphqlError = require("./FetchGraphqlError");
/**
 * Error that indicates that fetch to graphql server was successful, but had empty response
 */
class EmptyBodyFetchGraphqlError extends _FetchGraphqlError.FetchGraphqlError {
  constructor(response, query) {
    const message = 'Empty body returned from GraphQl server';
    // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
    super(new _axios.AxiosError(message, _axios.AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response), query);
    this.name = 'EmptyBodyFetchGraphqlError';
    this.message = message;
  }
}
exports.EmptyBodyFetchGraphqlError = EmptyBodyFetchGraphqlError;
//# sourceMappingURL=EmptyBodyFetchGraphqlError.js.map